/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BackgroundType = "GRADIENT" | "GRAPHIC" | "HOLIDAY";
export type SunflowerNavbar_viewer = {
    readonly profile?: {
        readonly background?: {
            readonly url: string;
            readonly type: BackgroundType;
            readonly name: string;
            readonly isUnlocked: boolean;
        } | undefined;
        readonly gamification?: {
            readonly coinsBalance: number | null;
        } | null | undefined;
    } | undefined;
    readonly " $refType": "SunflowerNavbar_viewer";
};
export type SunflowerNavbar_viewer$data = SunflowerNavbar_viewer;
export type SunflowerNavbar_viewer$key = {
    readonly " $data"?: SunflowerNavbar_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SunflowerNavbar_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableShop"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SunflowerNavbar_viewer",
  "selections": [
    {
      "condition": "enableShop",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DashboardBackground",
                  "kind": "LinkedField",
                  "name": "background",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isUnlocked",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Gamification",
                  "kind": "LinkedField",
                  "name": "gamification",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "coinsBalance",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Student",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '975e4b6b59e9f88ac5b10edfe9065b25';
export default node;
